import { HashRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./Components/Helpercomponents/ProtectedRoute.js";
import Login from "./pages/Login";
import Home from "./pages/Home";
import SingInPage from "./pages/SingUpPage.js";
import SaasProducts from "./pages/Products.js";
import Web from './web/index';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<SingInPage />} />
        <Route path="/products" element={<SaasProducts/>}/>
        <Route path="/web" element={<Web/>}/>
        <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}
